import { render, staticRenderFns } from "./StallholderSingleSelect.vue?vue&type=template&id=0fd6ca2d&scoped=true"
import script from "./StallholderSingleSelect.vue?vue&type=script&lang=js"
export * from "./StallholderSingleSelect.vue?vue&type=script&lang=js"
import style0 from "./StallholderSingleSelect.vue?vue&type=style&index=0&id=0fd6ca2d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd6ca2d",
  null
  
)

export default component.exports